/**
 * Navigation and link integrity. These are indicators, not proof — a single
 * airframe cannot prove it is being spoofed, only report that what it receives
 * stopped being physically plausible. The UI says it that way too.
 */

import { api, type ApiResult } from '@/api/client';

export interface IntegrityFinding {
  indicator: string;
  severity: 'caution' | 'critical' | string;
  detail: string;
}

export interface IntegrityReport {
  drones: Record<string, { severity: string | null; findings: IntegrityFinding[] }>;
  checked: number;
}

/** Human wording for each indicator, for a badge or a list row. */
export const INDICATOR_LABEL: Record<string, string> = {
  gps_fix_lost: 'GPS FIX LOST',
  gps_satellites_collapsed: 'GNSS JAMMING SUSPECTED',
  gps_position_implausible: 'GNSS SPOOFING SUSPECTED',
  link_degraded: 'LINK DEGRADED',
  link_silent: 'LINK SILENT',
};

export function getIntegrity(): Promise<ApiResult<IntegrityReport>> {
  return api.get<IntegrityReport>('/integrity', { logged: false });
}
